import Matomo from 'matomo-ts'
import { MATOMO_SITE_ID, MATOMO_URL } from '@/constants'

Matomo.default().init(MATOMO_URL, MATOMO_SITE_ID)
